import React, { Component } from 'react';
import * as _ from 'lodash';
import * as PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import TransparentButton from '../../../../shared/button/transparent-button/TransparentButton';
import { RuleTypeLabelPipe } from '../../../../shared/pipes/RuleTypeLabelPipe';
import { getRuleCategoryFriendlyName } from '../../../../services/RuleCategory';
import {
    diffRuleChanges,
    fillRuleDescription,
    humanize,
    parseRuleVariable
} from '../simulation.model';

/*
  The rules of the sandbox with the values they have, to change the ones to try. What is changed is worked out from what is typed
  in against what the rule has, so a value that is typed back to the one the rule has is no change.
*/
export class RuleChangeEditor extends Component {
    static propTypes = {
        rules: PropTypes.array,
        // What is typed in, by rule type: { config: { variable: value }, enabled }
        edits: PropTypes.object,
        onChangeVariable: PropTypes.func,
        onChangeEnabled: PropTypes.func,
        onReset: PropTypes.func
    };

    isEnabled = rule => {
        const edit = this.props.edits[rule.ruleType];

        return edit && _.isBoolean(edit.enabled) ? edit.enabled : rule.enabled;
    };

    renderRule = rule => {
        const {
            edits,
            onChangeVariable,
            onChangeEnabled,
            onReset
        } = this.props;
        const changed = diffRuleChanges([rule], edits).length > 0;
        const edit = edits[rule.ruleType];
        // What the rule says is shown with the values that are typed in, as they are typed
        const values = _.mapValues(rule.ruleVariables, (text, name) => {
            const typed = _.get(edit, ['config', name]);

            return _.isNil(typed) ? parseRuleVariable(text).value : typed;
        });

        return (
            <div
                key={rule.ruleType}
                className={'sim-change' + (changed ? ' changed' : '')}
            >
                <div className={'sim-change-header'}>
                    <div>
                        <div className={'sim-change-title'}>
                            {RuleTypeLabelPipe(rule.ruleType)}
                        </div>
                        <div className={'sim-muted'}>
                            {fillRuleDescription(rule.rule, values)}
                        </div>
                    </div>
                    <div>
                        {changed && (
                            <TransparentButton
                                onClick={() => onReset(rule.ruleType)}
                            >
                                Undo
                            </TransparentButton>
                        )}
                        <label>
                            <Checkbox
                                color={'primary'}
                                checked={this.isEnabled(rule)}
                                onChange={event =>
                                    onChangeEnabled(
                                        rule.ruleType,
                                        event.target.checked
                                    )
                                }
                            />
                            Enabled
                        </label>
                    </div>
                </div>
                {!_.isEmpty(rule.ruleVariables) && (
                    <div className={'sim-change-variables sim-form'}>
                        {_.map(rule.ruleVariables, (text, name) => {
                            const parsed = parseRuleVariable(text);
                            const typed = _.get(edit, ['config', name]);

                            return (
                                <div key={name} className={'sim-field'}>
                                    <span className={'sim-label'}>
                                        {humanize(name)}
                                        {parsed.unit && (
                                            <span className={'sim-muted'}>
                                                {' '}
                                                ({parsed.unit})
                                            </span>
                                        )}
                                    </span>
                                    <input
                                        type={'text'}
                                        value={
                                            _.isNil(typed)
                                                ? parsed.value
                                                : typed
                                        }
                                        onChange={event =>
                                            onChangeVariable(
                                                rule.ruleType,
                                                name,
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    };

    render() {
        const groups = _.groupBy(
            _.sortBy(this.props.rules, 'ruleType'),
            'ruleCategory'
        );

        if (_.isEmpty(this.props.rules)) {
            return (
                <span className={'sim-muted'}>The sandbox has no rules.</span>
            );
        }

        return (
            <div className={'sim-rule-editor'}>
                {_.map(groups, (rules, category) => (
                    <div key={category}>
                        <div className={'sim-category-title'}>
                            {getRuleCategoryFriendlyName(category) || category}
                        </div>
                        {rules.map(this.renderRule)}
                    </div>
                ))}
            </div>
        );
    }
}
